import clsx from 'clsx';

import { DropdownOption, DropdownTemplate, DropdownEvent } from '../types';
import { useEffect, useRef } from 'react';

interface DropdownItemProps {
	option: DropdownOption;
	isSelected: boolean;
	template: DropdownTemplate;
	analyseKey?: string;
	setShowMenu: (isShowMenu: boolean) => void;
	onChange?(event: DropdownEvent): void;
	onOpenToggled?(isOpen: boolean): void;
}

export const DropdownItem = ({
	option,
	isSelected,
	template,
	analyseKey,
	setShowMenu,
	onChange,
	onOpenToggled
}: DropdownItemProps) => {
	const taggedElement = useRef<HTMLDivElement>(null);
	const content = template 
		? template(option) 
		: (
			<span className="dropdown__item-text">
				{option.label}
			</span>
		);

	const changeOption = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		setShowMenu(false);
		onChange && onChange({ option });
		onOpenToggled && onOpenToggled(false);
	};
	useEffect(() => {
		const canNotActive = !analyseKey || !taggedElement.current || typeof taggedElement.current.setAttribute !== 'function';
		if (canNotActive) {
			return;
		}
		taggedElement.current.setAttribute('nextanalyse', analyseKey);
	}, []);

	return (
		<div 
			className={
				clsx(
					'dropdown__item', 
					option.className, 
				)}
			data-selected={isSelected}
			onClick={changeOption}
			ref={taggedElement}
		>
			{content}
		</div>
	);
};